module.exports = __webpack_public_path__ + "static/media/historia.f6e39b9a.png";